const SET_AMENDMENT = (state, amendment) => {
	state.selectedAmendment = amendment
}

const SET_AMENDMENT_ATTACHMENTS = (state, files) => {
	state.selectedAmendment = {
		...state.selectedAmendment,
		attachments: files,
	}
}

const SET_CURRENT_RESEARCHER = (state, researcher) => {
	state.researcher = researcher
}

const SET_ASSIGNED_REVIEWERS = (state, assignedReviewers) => {
	state.assignedReviewers = assignedReviewers
}

const SET_DICTUMS = (state, dictums) => {
	state.dictums = dictums
}

const ADD_DATE = (state, date) => {
	state.dates.unshift(date)
}

const SET_DATES = (state, dates) => {
	state.dates = dates
}

const SET_REVIEWERS = (state, reviewers) => {
	state.reviewers = reviewers
}

const SET_COMMITEE_DICTUMS = (state, dictums) => {
	state.committeeDictums = dictums
}

const SET_DICTUM_TYPES = (state, dictumTypes) => {
	state.dictumTypes = dictumTypes
}

const SET_AMENDMENT_FINANCING_INFORMATION = (state, financingInformation) => {
	state.selectedAmendment = {
		...state.selectedAmendment,
		financing_information: financingInformation,
	}
}

const SET_AMENDMENT_FUNDERS = (state, funders) => {
	state.funders = funders
}

const UPDATE_AMENDMENT_FUNDERS = (state, funders) => {
	state.funders = [...funders]
}

const UPDATE_FINANCING_COMMITMENTS = (state, financingCommitments) => {
	state.financingCommitments = [...financingCommitments]
}

const SET_AMENDMENT_RESEARCHERS = (state, researchers) => {
	state.researchers = researchers
}

const SET_AMENDMENT_EXTERNAL_RESEARCHERS = (state, externalResearchers) => {
	state.externalResearchers = externalResearchers
}

export default {
	SET_AMENDMENT,
	SET_AMENDMENT_ATTACHMENTS,
	SET_CURRENT_RESEARCHER,
	SET_ASSIGNED_REVIEWERS,
	SET_DICTUMS,
	ADD_DATE,
	SET_DATES,
	SET_REVIEWERS,
	SET_COMMITEE_DICTUMS,
	SET_DICTUM_TYPES,
	SET_AMENDMENT_FINANCING_INFORMATION,
	SET_AMENDMENT_FUNDERS,
	UPDATE_AMENDMENT_FUNDERS,
	UPDATE_FINANCING_COMMITMENTS,
	SET_AMENDMENT_RESEARCHERS,
	SET_AMENDMENT_EXTERNAL_RESEARCHERS,
}
